import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "cap" ]

  connect() {
    const checkbox = this.element.querySelector('input[type="checkbox"][name*="distributor_featured"]')
    if (checkbox) this.toggleFromCheckbox(checkbox.checked)
  }

  toggle(event) {
    const checked = event.target ? event.target.checked : !!event
    this.toggleFromCheckbox(checked)
  }

  toggleFromCheckbox(checked) {
    if (!this.hasCapTarget) return
    this.capTarget.classList.toggle("d-none", !checked)
  }
}
